import { css, styled, Typography } from '@mui/material';

export const GridW = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white.main};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  gap: 0;
`;

export const ListW = styled('div')<{ isFullView: boolean }>`
  display: grid;
  grid-template-columns: repeat(3, minmax(32%, 1fr));
  grid-template-rows: 1fr;
  gap: 16px;

  ${({ isFullView }) =>
    isFullView &&
    css`
      display: flex;
      gap: 24px;
    `};

  @media (max-width: 1280px) and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const MobileListW = styled('div')<{ isBackground: boolean }>`
  width: 100%;
  margin-top: 8px;
  position: relative;

  ${({ isBackground }) =>
    isBackground &&
    css`
      @media (max-width: 1023px) {
        padding-bottom: 16px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(10px);
      }
    `}
`;

export const ListFooterW = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const DesktopListW = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow-x: scroll;
  width: 100%;
`;

export const SeeMoreW = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.main};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;
